import { render, staticRenderFns } from "./IbButton.vue?vue&type=template&id=670cc141&scoped=true"
import script from "./IbButton.vue?vue&type=script&lang=js"
export * from "./IbButton.vue?vue&type=script&lang=js"
import style0 from "./IbButton.vue?vue&type=style&index=0&id=670cc141&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670cc141",
  null
  
)

export default component.exports